import React from "react";
import PropTypes from "prop-types";
import { BOWLS_TYPES } from "./BowlsTypes";
import { useCartContext } from "../../global/cartContext";
import { getQuantityOfRequiredReusableBowls } from "../../Helpers/reusable-bowls-utils";

const ReusableBowlToggle = ({ bowlType, onToggle, disabled }) => {
    const { cart } = useCartContext();
    const canGetReusableBowls =
        getQuantityOfRequiredReusableBowls(cart.items) > 0;

    const isActive = bowlType === BOWLS_TYPES.REUSABLE ? "active" : "";
    return (
        <div className="reusable-toggle" disabled={disabled}>
            <div
                className={`toggle ${isActive}`}
                onClick={() => !disabled && canGetReusableBowls && onToggle()}
            >
                <div className={`option ${isActive}`}></div>
            </div>
        </div>
    );
};

ReusableBowlToggle.propTypes = {
    disabled: PropTypes.bool,
    bowlType: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default ReusableBowlToggle;
